import apiClient from '../axios';
export default {
    login(credenciales) {
        return apiClient.post('/login', credenciales);
    }
}